import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import axios from "axios";
import ProductCard from "../components/ProductCard";
import SEO from "../components/SEO";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ShopPage() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("all");

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        let url = `${API}/products`;
        if (filter === "featured") {
          url += "?featured=true";
        }
        const response = await axios.get(url);
        setProducts(response.data);
      } catch (error) {
        console.error("Error fetching products:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchProducts();
  }, [filter]);

  return (
    <div className="min-h-screen pt-32 pb-24 px-6 md:px-12" data-testid="shop-page">
      <SEO title="Shop All Tanks" description="Browse the 3T collection. Premium tank tops with bold motivational messages. Sizes M, L, XL. A$56 each. Free shipping on 3+ items." />
      <div className="max-w-[1400px] mx-auto">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="mb-12"
        >
          <p className="font-mono text-[#FFD700] text-sm tracking-[0.3em] mb-2">
            COLLECTION
          </p>
          <h1 className="font-heading text-5xl md:text-7xl tracking-tight uppercase">
            ALL TANKS
          </h1>
        </motion.div>

        {/* Products Grid */}
        {loading ? (
          <div className="flex justify-center py-20">
            <div className="loader" />
          </div>
        ) : products.length === 0 ? (
          <div className="text-center py-20">
            <p className="text-[#A3A3A3] text-lg">No products found</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8 product-grid">
            {products.map((product, index) => (
              <ProductCard key={product.id} product={product} index={index} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
